import { type CommandProperties } from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export interface InlineInputBoxTraceMessageCommandProperties extends CommandProperties {
	message_template: string;
	action_key?: string;
}

/**
 * A command sent by the rovo client to send the trace message to the inline input box.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to trace the ongoing message.
 */
export const InlineInputBoxTraceMessageCommand = createCommand<
	InlineInputBoxTraceMessageCommandProperties,
	void
>('inline-input-box-trace-message-command');
